/* eslint-disable @atlaskit/design-system/no-legacy-icons */
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import NewMentionIcon from '@atlaskit/icon/core/mention';
import React from 'react';

const MentionIcon = (props: Omit<NewCoreIconProps, 'spacing'>) => {
  return <NewMentionIcon spacing="spacious" {...props} />;
};

export default MentionIcon;
